import React, {useEffect, useState} from 'react';
import DataFreshness from './DataFreshness';
import {analyticsFetch as fetch} from './analyticsPolling';

const number = (value) => Number(value).toLocaleString('en-GB');

export default function AutomationSegmentResults(initial) {
  const [data,setData] = useState(initial);
  const [error,setError] = useState('');
  const [reload,setReload] = useState(0);
  const url = `/automation-chains/${initial.chain.id}/segment_results`;
  useEffect(() => {
    let request;
    let active = true;
    const refresh = async () => {
      request?.abort(); request = new AbortController(); const current = request;
      try {
        const response = await fetch(`${url}${initial.version_id ? `?version_id=${initial.version_id}` : ''}`,{headers:{Accept:'application/json'},signal:current.signal});
        if (!response.ok) throw new Error('Could not update results. Try again.');
        const result = await response.json();
        if (active && !current.signal.aborted) {setData(result);setError('');}
      } catch (err) {if (active && err.name !== 'AbortError') setError(err.message);}
    };
    const interval = setInterval(refresh,5000);
    if (reload) refresh();
    return () => {active=false;clearInterval(interval);request?.abort();};
  },[url,initial.version_id,reload]);
  return <main className='automation-chains chain-split-results'>
    <a className='chain-link' href={`/automation-chains/${data.chain.id}/builder`}>← Chain diagram</a>
    <header className='chain-page-header'><div><h1>Add to Segment results</h1><p>{data.chain.name}</p></div>
      {data.versions.length > 0 && <form action={url} method='get' className='split-version-form'>
        <label>Published version <select name='version_id' aria-label='Published version' defaultValue={data.version_id}>
          {data.versions.map((version) => <option key={version.id} value={version.id}>Version {version.number}</option>)}
        </select></label><button className='chain-button' type='submit'>View</button>
      </form>}
    </header>
    <p className='chain-help'>Players added counts unique Player IDs newly inserted by each node. Existing memberships are skipped without interrupting the chain. Results are kept per published version and update every 5 seconds.</p>
    <DataFreshness freshness={data.freshness} updatedAt={data.updated_at} error={error} />
    {error && <p role='alert' className='chain-error'>{error} <button className='chain-button' onClick={() => setReload((value) => value+1)}>Retry</button></p>}
    {!data.version_id && <p className='chain-empty'>Start the chain to publish a version and collect Add to Segment results.</p>}
    {data.version_id && !data.results.length && <p className='chain-empty'>This published version has no Add to Segment nodes.</p>}
    {data.results.length > 0 && <div className='chain-table-wrap'><table className='chain-table'><thead><tr>
      <th>Node</th><th>Manual Segment</th><th className='split-numeric'>Players added</th><th className='split-numeric'>New memberships</th><th className='split-numeric'>Already members</th><th className='split-numeric'>Failed</th>
    </tr></thead><tbody>{data.results.map((node) => <tr key={node.node_id}>
      <td>{node.label}</td><td><a className='chain-link' href={`/segments/${node.segment_id}`}>{node.segment_name}</a></td>
      <td className='split-numeric'>{number(node.players_added)}</td><td className='split-numeric'>{number(node.additions)}</td>
      <td className='split-numeric'>{number(node.already_members)}</td><td className='split-numeric'>{number(node.failed)}</td>
    </tr>)}</tbody></table></div>}
  </main>;
}
